"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4881],{

/***/ 88116:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "a": function() { return /* binding */ Action; }
/* harmony export */ });
/* harmony import */ var _emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92952);

var Action = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("div",  true ? {
  target: "ecuy6w40"
} : 0)("justify-self:", function (_ref) {
  var alignment = _ref.alignment;
  return alignment;
}, ";align-self:end;svg{transition:0.3s transform;}" + ( true ? "" : 0));

/***/ }),

/***/ 41171:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "u": function() { return /* binding */ Body; }
/* harmony export */ });
/* harmony import */ var _emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92952);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(28165);


function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}



var _ref =  true ? {
  name: "1n0oxv1",
  styles: "grid-area:body;padding:32px"
} : 0;

var Body = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("div",  true ? {
  target: "e1ss3rom0"
} : 0)("display:grid;gap:24px;justify-items:start;grid-template-rows:max-content;", function (_ref2) {
  var layout = _ref2.layout;
  return layout === "vertical" && _ref;
}, " ", function (_ref3) {
  var layout = _ref3.layout,
      theme = _ref3.theme;
  return layout === "horizontal" &&
  /*#__PURE__*/

  /*#__PURE__*/
  (0,_emotion_react__WEBPACK_IMPORTED_MODULE_1__/* .css */ .iv)("padding:48px;", theme.breakpoints.down("md"), "{grid-area:body;padding:32px;}" + ( true ? "" : 0),  true ? "" : 0,  true ? "" : 0,  true ? "" : 0);
}, ";" + ( true ? "" : 0));

/***/ }),

/***/ 44199:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Card; },
/* harmony export */   "i": function() { return /* binding */ Wrapper; }
/* harmony export */ });
/* harmony import */ var _emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92952);
/* harmony import */ var _emotion_react__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(28165);
/* harmony import */ var _segment_matcha_components_Paper__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(16164);
/* harmony import */ var _segment_matcha_components_ButtonText_ButtonText_views__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(54351);
/* harmony import */ var _segment_matcha_components_Button_Button_views__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(24945);
/* harmony import */ var _segment_matcha_components_Icons_wrappers_IconWrapper__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(59844);
/* harmony import */ var _Action_Action_views__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(88116);
/* harmony import */ var _Description_Description_views__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(25488);


function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}








var Wrapper = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("div",  true ? {
  target: "e1iid5mn1"
} : 0)( true ? {
  name: "18e4vzk",
  styles: "display:inline-block;text-decoration:none"
} : 0);

var _ref =  true ? {
  name: "b4anze",
  styles: "grid-template-rows:max-content;grid-template-areas:'image' 'body'"
} : 0;

var Card = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_segment_matcha_components_Paper__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z,  true ? {
  target: "e1iid5mn0"
} : 0)("overflow:hidden;display:grid;overflow:hidden;transition:box-shadow 0.3s;width:auto;color:", function (_ref2) {
  var color = _ref2.color;
  return color;
}, ";", _Description_Description_views__WEBPACK_IMPORTED_MODULE_6__/* .Description */ .d, "{color:", function (_ref3) {
  var descriptionColor = _ref3.descriptionColor;
  return descriptionColor;
}, ";}", function (_ref4) {
  var layout = _ref4.layout;
  return layout === "vertical" && _ref;
}, " ", function (_ref5) {
  var layout = _ref5.layout,
      theme = _ref5.theme;
  return layout === "horizontal" &&
  /*#__PURE__*/

  /*#__PURE__*/
  (0,_emotion_react__WEBPACK_IMPORTED_MODULE_7__/* .css */ .iv)("grid-template-columns:auto auto;", theme.breakpoints.down("md"), "{grid-template-areas:'image' 'body';}" + ( true ? "" : 0),  true ? "" : 0,  true ? "" : 0,  true ? "" : 0);
}, " ", _segment_matcha_components_ButtonText_ButtonText_views__WEBPACK_IMPORTED_MODULE_2__/* .ButtonText */ .o, ",", _segment_matcha_components_Button_Button_views__WEBPACK_IMPORTED_MODULE_3__/* .Button */ .zx, "{pointer-events:", function (_ref6) {
  var pointerEvents = _ref6.pointerEvents;
  return pointerEvents;
}, ";}:hover{box-shadow:", function (_ref7) {
  var theme = _ref7.theme;
  return theme.shadows[4];
}, ";", _Action_Action_views__WEBPACK_IMPORTED_MODULE_5__/* .Action */ .a, "{", _segment_matcha_components_ButtonText_ButtonText_views__WEBPACK_IMPORTED_MODULE_2__/* .ButtonText */ .o, "{", _segment_matcha_components_ButtonText_ButtonText_views__WEBPACK_IMPORTED_MODULE_2__/* .hoverStyles */ .Z, ";}", _segment_matcha_components_Button_Button_views__WEBPACK_IMPORTED_MODULE_3__/* .Button */ .zx, "{", _segment_matcha_components_Button_Button_views__WEBPACK_IMPORTED_MODULE_3__/* .hoverStyles */ .ZT, ";}&>", _segment_matcha_components_Icons_wrappers_IconWrapper__WEBPACK_IMPORTED_MODULE_4__/* .Wrapper */ .i, " svg{transform:translateX(5px);}}}" + ( true ? "" : 0));

/***/ }),

/***/ 99534:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C": function() { return /* binding */ Copy; }
/* harmony export */ });
/* harmony import */ var _emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92952);


function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}

var Copy = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)("div",  true ? {
  target: "e1tugjmz0"
} : 0)( true ? {
  name: "budh8k",
  styles: "display:flex;flex-direction:column;gap:16px"
} : 0);

/***/ }),

/***/ 25488:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "d": function() { return /* binding */ Description; }
/* harmony export */ });
/* harmony import */ var _emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(92952);
/* harmony import */ var _segment_matcha_components_Typography__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(89533);


var Description = /*#__PURE__*/(0,_emotion_styled_base__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(_segment_matcha_components_Typography__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z,  true ? {
  target: "e6vfs3p0"
} : 0)("margin:0;display:-webkit-box;-webkit-box-orient:vertical;-webkit-line-clamp:7;overflow:hidden;", function (_ref) {
  var theme = _ref.theme;
  return theme.breakpoints.up("xl");
}, "{-webkit-line-clamp:8;}" + ( true ? "" : 0));

/***/ }),

/***/ 74881:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "v8": function() { return /* reexport */ Accessories_Accessories; },
  "OW": function() { return /* reexport */ AccessoriesRow_AccessoriesRow; },
  "aU": function() { return /* reexport */ Action_Action; },
  "S3": function() { return /* reexport */ Author_Author; },
  "uT": function() { return /* reexport */ Body_Body; },
  "CK": function() { return /* reexport */ Copy_Copy; },
  "dk": function() { return /* reexport */ Description_Description; },
  "s0": function() { return /* reexport */ Headline_Headline; },
  "Ee": function() { return /* reexport */ Card_Image_Image; },
  "__": function() { return /* reexport */ Label_Label; },
  "ZP": function() { return /* reexport */ Card_Card; }
});

// UNUSED EXPORTS: Logo

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js
var defineProperty = __webpack_require__(95235);
// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js + 1 modules
var objectWithoutProperties = __webpack_require__(82269);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../libs/matcha/foundations/AppearanceContext/index.ts + 1 modules
var AppearanceContext = __webpack_require__(9381);
// EXTERNAL MODULE: ../../libs/matcha/useDesignTokens/index.ts
var useDesignTokens = __webpack_require__(98439);
// EXTERNAL MODULE: ../../libs/matcha/recipes/Card/Card.views.ts
var Card_views = __webpack_require__(44199);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(52903);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Card/CardContext.tsx


function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}



var CardContext = /*#__PURE__*/(0,react.createContext)(null);
var CardProvider = CardContext.Provider;
var CardContextProvider = function CardContextProvider(_ref) {
  var value = _ref.value,
      children = _ref.children;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CardContext.Provider, {
    value: _objectSpread({}, value),
    children: children
  });
};
var useCardContext = function useCardContext() {
  var state = (0,react.useContext)(CardContext);

  if (state === null) {
    throw new Error("Card context isn't available.");
  }

  return state;
};
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Card/Card.tsx


var _excluded = ["children", "appearance", "tag", "layout", "href", "tokens"];

function Card_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function Card_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? Card_ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Card_ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}







var BaseCard = /*#__PURE__*/(0,react.forwardRef)(function (_ref, ref) {
  var children = _ref.children,
      externalAppearance = _ref.appearance,
      tag = _ref.tag,
      _ref$layout = _ref.layout,
      layout = _ref$layout === void 0 ? "vertical" : _ref$layout,
      href = _ref.href,
      tokens = _ref.tokens,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, _excluded);

  var appearance = (0,AppearanceContext/* useAppearance */.M)(externalAppearance);
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AppearanceContext/* AppearanceProvider */.x, {
    appearance: appearance === "twilioLight" || appearance === "cdpWeek2023" ? appearance : "light",
    children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CardContextProvider, {
      value: {
        layout: layout
      },
      children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Card_views/* Wrapper */.i, Card_objectSpread(Card_objectSpread({
        as: tag !== null && tag !== void 0 ? tag : href ? "a" : undefined,
        href: href,
        ref: ref
      }, rest), {}, {
        children: (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Card_views/* Card */.Z, Card_objectSpread(Card_objectSpread({
          layout: layout,
          elevation: 2
        }, tokens), {}, {
          children: children
        }))
      }))
    })
  });
});
var Card = (0,useDesignTokens/* withDesignTokens */.Y)(BaseCard, function (props) {
  return {
    pointerEvents: props.tag === "a" ? "none" : "auto"
  };
}, {
  light: function light(theme) {
    return {
      color: theme.palette.brand.darkAcai[700],
      descriptionColor: theme.palette.brand.darkAcai[700],
      background: theme.palette.neutrals.white[100]
    };
  },
  dark: function dark(theme) {
    return {
      color: theme.palette.brand.darkAcai[700],
      descriptionColor: theme.palette.brand.darkAcai[700],
      background: theme.palette.neutrals.white[100]
    };
  },
  twilioLight: function twilioLight(theme) {
    return {
      color: theme.palette.twilio.gray[100],
      descriptionColor: theme.palette.twilio.gray[100],
      background: theme.palette.neutrals.white[100]
    };
  },
  cdpWeek2023: function cdpWeek2023(theme) {
    return {
      color: theme.palette.neutrals.white[100],
      descriptionColor: theme.palette.cdpWeek2023.gray[10],
      background: theme.palette.cdpWeek2023.gray[90]
    };
  }
});
/* harmony default export */ var Card_Card = (Card);
// EXTERNAL MODULE: ../../node_modules/@emotion/styled/base/dist/emotion-styled-base.browser.esm.js
var emotion_styled_base_browser_esm = __webpack_require__(92952);
// EXTERNAL MODULE: ../../node_modules/@emotion/react/dist/emotion-react.browser.esm.js
var emotion_react_browser_esm = __webpack_require__(28165);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Card/Image/Image.views.ts


var Image = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("img",  true ? {
  target: "ettcslb0"
} : 0)("object-fit:cover;object-position:center;aspect-ratio:1;", function (_ref) {
  var layout = _ref.layout,
      variant = _ref.variant;
  return layout === "vertical" &&
  /*#__PURE__*/

  /*#__PURE__*/
  (0,emotion_react_browser_esm/* css */.iv)("width:100%;height:180px;grid-area:image;height:180px;padding:", variant === "fixed" ? "24px 32px 0" : "0", ";" + ( true ? "" : 0),  true ? "" : 0,  true ? "" : 0,  true ? "" : 0);
}, " ", function (_ref2) {
  var layout = _ref2.layout,
      variant = _ref2.variant,
      theme = _ref2.theme;
  return layout === "horizontal" &&
  /*#__PURE__*/

  /*#__PURE__*/
  (0,emotion_react_browser_esm/* css */.iv)("width:100%;grid-area:image;height:180px;padding:", variant === "fixed" ? "24px 32px 0" : "0", ";", theme.breakpoints.up("lg"), "{width:351px;grid-area:unset;height:0;min-height:100%;padding:", variant === "fixed" ? "40px 0 40px 40px" : "0", ";}" + ( true ? "" : 0),  true ? "" : 0,  true ? "" : 0,  true ? "" : 0);
}, ";" + ( true ? "" : 0));
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Card/Image/Image.tsx


var Image_excluded = ["src", "alt", "variant", "width", "height"];

function Image_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function Image_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? Image_ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Image_ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}





var Image_Image = /*#__PURE__*/(0,react.memo)(function (_ref) {
  var src = _ref.src,
      alt = _ref.alt,
      variant = _ref.variant,
      width = _ref.width,
      height = _ref.height,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, Image_excluded);

  var cardContext = useCardContext();
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Image, Image_objectSpread({
    src: src,
    alt: alt,
    width: width,
    height: height,
    variant: variant,
    layout: cardContext === null || cardContext === void 0 ? void 0 : cardContext.layout
  }, rest));
});
/* harmony default export */ var Card_Image_Image = (Image_Image);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Card/Image/index.ts

// EXTERNAL MODULE: ../../libs/matcha/recipes/Card/Body/Body.views.ts
var Body_views = __webpack_require__(41171);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Card/Body/Body.tsx


var Body_excluded = ["children"];

function Body_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function Body_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? Body_ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Body_ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}





var Body = function Body(_ref) {
  var children = _ref.children,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, Body_excluded);

  var cardContext = useCardContext();
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Body_views/* Body */.u, Body_objectSpread(Body_objectSpread({}, rest), {}, {
    layout: cardContext === null || cardContext === void 0 ? void 0 : cardContext.layout,
    children: children
  }));
};

/* harmony default export */ var Body_Body = (Body);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Card/Body/index.ts

// EXTERNAL MODULE: ../../libs/matcha/components/Typography/index.ts
var Typography = __webpack_require__(89533);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Card/Headline/Headline.views.tsx


var Headline = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Typography/* default */.Z,  true ? {
  target: "egral9n0"
} : 0)("margin:0;display:-webkit-box;-webkit-box-orient:vertical;-webkit-line-clamp:3;overflow:hidden;", function (_ref) {
  var theme = _ref.theme;
  return theme.breakpoints.up("xl");
}, "{-webkit-line-clamp:4;}" + ( true ? "" : 0));
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Card/Headline/Headline.tsx


var Headline_excluded = ["variant", "children"];

function Headline_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function Headline_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? Headline_ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Headline_ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}



var Heading = function Heading(_ref) {
  var _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? "h4" : _ref$variant,
      children = _ref.children,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, Headline_excluded);

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Headline, Headline_objectSpread(Headline_objectSpread({
    variant: variant
  }, rest), {}, {
    children: children
  }));
};
/* harmony default export */ var Headline_Headline = (Heading);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Card/Headline/index.ts

// EXTERNAL MODULE: ../../libs/matcha/recipes/Card/Description/Description.views.tsx
var Description_views = __webpack_require__(25488);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Card/Description/Description.tsx


var Description_excluded = ["variant", "children"];

function Description_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function Description_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? Description_ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Description_ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}



var Description = function Description(_ref) {
  var _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? "pSmall" : _ref$variant,
      children = _ref.children,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, Description_excluded);

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Description_views/* Description */.d, Description_objectSpread(Description_objectSpread({
    variant: variant
  }, rest), {}, {
    children: children
  }));
};
/* harmony default export */ var Description_Description = (Description);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Card/Description/index.ts

// EXTERNAL MODULE: ../../libs/matcha/recipes/Card/Copy/Copy.views.ts
var Copy_views = __webpack_require__(99534);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Card/Copy/Copy.tsx



var Copy = function Copy(_ref) {
  var children = _ref.children;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Copy_views/* Copy */.C, {
    children: children
  });
};

/* harmony default export */ var Copy_Copy = (Copy);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Card/Copy/index.ts

;// CONCATENATED MODULE: ../../libs/matcha/recipes/Card/Accessories/Accessories.views.ts


function _EMOTION_STRINGIFIED_CSS_ERROR__() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}

var Accessories_views_Accessories = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e17oxwus0"
} : 0)( true ? {
  name: "k2whb",
  styles: "display:grid;gap:18px"
} : 0);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Card/Accessories/Accessories.tsx



var Accessories = function Accessories(_ref) {
  var children = _ref.children;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Accessories_views_Accessories, {
    children: children
  });
};

/* harmony default export */ var Accessories_Accessories = (Accessories);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Card/Accessories/index.ts

;// CONCATENATED MODULE: ../../libs/matcha/recipes/Card/AccessoriesRow/AccessoriesRow.views.ts


function AccessoriesRow_views_EMOTION_STRINGIFIED_CSS_ERROR_() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}

var AccessoriesRow_views_AccessoriesRow = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)("div",  true ? {
  target: "e1hwwt3r0"
} : 0)( true ? {
  name: "lyd1mn",
  styles: "display:flex;flex-wrap:wrap;align-items:center;gap:8px"
} : 0);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Card/AccessoriesRow/AccessoriesRow.tsx



var AccessoriesRow = function AccessoriesRow(_ref) {
  var children = _ref.children;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(AccessoriesRow_views_AccessoriesRow, {
    children: children
  });
};

/* harmony default export */ var AccessoriesRow_AccessoriesRow = (AccessoriesRow);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Card/AccessoriesRow/index.ts

;// CONCATENATED MODULE: ../../libs/matcha/recipes/Card/Label/Label.views.ts


function Label_views_EMOTION_STRINGIFIED_CSS_ERROR_() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}


var Label_views_Label = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(Typography/* default */.Z,  true ? {
  target: "esw1ezs0"
} : 0)( true ? {
  name: "ti75j2",
  styles: "margin:0"
} : 0);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Card/Label/Label.tsx


var Label_excluded = ["children", "variant"];

function Label_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function Label_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? Label_ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Label_ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}



var Label = function Label(_ref) {
  var children = _ref.children,
      _ref$variant = _ref.variant,
      variant = _ref$variant === void 0 ? "textBoldSmall" : _ref$variant,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, Label_excluded);

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Label_views_Label, Label_objectSpread(Label_objectSpread({
    variant: variant
  }, rest), {}, {
    children: children
  }));
};
/* harmony default export */ var Label_Label = (Label);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Card/Label/index.ts

// EXTERNAL MODULE: ../../libs/matcha/recipes/Card/Action/Action.views.ts
var Action_views = __webpack_require__(88116);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Card/Action/Action.tsx


var Action = function Action(_ref) {
  var children = _ref.children,
      _ref$alignment = _ref.alignment,
      alignment = _ref$alignment === void 0 ? "left" : _ref$alignment;
  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Action_views/* Action */.a, {
    alignment: alignment,
    children: children
  });
};
/* harmony default export */ var Action_Action = (Action);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Card/Action/index.ts

// EXTERNAL MODULE: ../../libs/matcha/components/Image/index.ts + 2 modules
var components_Image = __webpack_require__(4203);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Card/Logo/Logo.views.ts


var Logo = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(components_Image/* default */.Z,  true ? {
  target: "etuzh340"
} : 0)("width:32px;height:32px;border-radius:50%;margin:0;border:1px solid ", function (_ref) {
  var borderColor = _ref.borderColor;
  return borderColor;
}, ";" + ( true ? "" : 0));
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Card/Logo/Logo.tsx


var Logo_excluded = ["src", "alt", "tokens"];

function Logo_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function Logo_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? Logo_ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Logo_ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}





var LogoBase = function LogoBase(_ref) {
  var src = _ref.src,
      alt = _ref.alt,
      tokens = _ref.tokens,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, Logo_excluded);

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Logo, Logo_objectSpread(Logo_objectSpread(Logo_objectSpread({
    src: src,
    alt: alt
  }, tokens), rest), {}, {
    width: "32",
    height: "32"
  }));
};

var Logo_Logo = (0,useDesignTokens/* withDesignTokens */.Y)(LogoBase, function () {
  return {};
}, {
  light: function light(theme) {
    return {
      borderColor: theme.palette.brand.darkAcai[700]
    };
  },
  dark: function dark(theme) {
    return {
      borderColor: theme.palette.brand.darkAcai[700]
    };
  },
  twilioLight: function twilioLight(theme) {
    return {
      borderColor: theme.palette.twilio.gray[100]
    };
  }
});
/* harmony default export */ var Card_Logo_Logo = ((/* unused pure expression or super */ null && (Logo_Logo)));
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Card/Logo/index.ts

// EXTERNAL MODULE: ../../libs/utils/contentfulImageLoader/contentfulImageLoader.ts
var contentfulImageLoader = __webpack_require__(1959);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Card/Author/Author.views.ts


function Author_views_EMOTION_STRINGIFIED_CSS_ERROR_() {
  return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}



var _ref =  true ? {
  name: "68x97p",
  styles: "width:32px;height:32px"
} : 0;

var _ref2 =  true ? {
  name: "1mfsro6",
  styles: "width:40px;height:40px"
} : 0;

var Author_views_Author = /*#__PURE__*/(0,emotion_styled_base_browser_esm/* default */.Z)(components_Image/* default */.Z,  true ? {
  target: "e1m0srff0"
} : 0)("object-fit:cover;margin:0;", function (_ref3) {
  var size = _ref3.size;
  return size === "medium" && _ref2;
}, " ", function (_ref4) {
  var size = _ref4.size;
  return size === "small" && _ref;
}, " border-radius:50%;" + ( true ? "" : 0));
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Card/Author/Author.tsx


var Author_excluded = ["src", "alt", "size", "contentfulLoader"];

function Author_ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function Author_objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? Author_ownKeys(Object(source), !0).forEach(function (key) {
      (0,defineProperty/* default */.Z)(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : Author_ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}




var Author = function Author(_ref) {
  var src = _ref.src,
      alt = _ref.alt,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? "medium" : _ref$size,
      contentfulLoader = _ref.contentfulLoader,
      rest = (0,objectWithoutProperties/* default */.Z)(_ref, Author_excluded);

  return (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Author_views_Author, Author_objectSpread({
    loader: contentfulLoader ? contentfulImageLoader/* default */.Z : undefined,
    src: src,
    alt: alt,
    width: size === "medium" ? "40" : "32",
    height: size === "medium" ? "40" : "32",
    size: size
  }, rest));
};
/* harmony default export */ var Author_Author = (Author);
;// CONCATENATED MODULE: ../../libs/matcha/recipes/Card/Author/index.ts

;// CONCATENATED MODULE: ../../libs/matcha/recipes/Card/index.ts












Card_Card.displayName = "CardBase";
Body_Body.displayName = "Card.Body";
Card_Image_Image.displayName = "Card.Image";
Headline_Headline.displayName = "Card.Headline";
Description_Description.displayName = "Card.Description";
Copy_Copy.displayName = "Card.Copy";
Accessories_Accessories.displayName = "Card.Accessories";
AccessoriesRow_AccessoriesRow.displayName = "Card.AccessoriesRow";
Label_Label.displayName = "Card.Label";
Action_Action.displayName = "Card.Action";
Author_Author.displayName = "Card.Author";


/***/ })

}]);